export default {
    name: 'actionModal',
    props: {
      title: {
          type: String,
          default: 'Confirm action'
      },
        test: {
          type: String
        }
    },
    methods: {
        changeVision() {
            this.$emit('close-n-redirect')
        }
    }
}
